import {Injectable} from '@angular/core';

export class AppUserData {
	public login;
	public token;
	public groups = [];
}


@Injectable()
export class AppUser {

	// as we are using it before Angular is loaded we cannot just use injection
	public static data: AppUserData = new AppUserData();

	public static setData(data: AppUserData) {
		AppUser.data = data;
	}

	public getToken() {
		return AppUser.data.token;
	}

	public getLogin() {
		return AppUser.data.login;
	}

	hasGroup(gNeeded) {
		if (AppUser.data.login == null) {
			// console.log('user not allowed', 'no session', AppUser.data);
			return false;
		}
		const groups = AppUser.data.groups;
		// console.log('groups', groups);

		for (const g of groups) {
			if (g === gNeeded) {
				return true;
			}
		}
		return false;
	}

	isAllowed(rights) {
		// console.log('isAllowed', rights, environment.session.user.rights);
		if (AppUser.data.login == null) {
			// console.log('user not allowed', 'no session', AppUser.data);
			return false;
		}
		if (!rights) {
			// console.log('user not allowed', 'no right argument');
			return false; // weird one
		}

		// !INTERN
		const groups = AppUser.data.groups;

		const rightsOfUser = {};
		for (const g of groups) {
			switch (g) {
				case 'ADMINS':
					rightsOfUser['ACCESS_INACTIVE_USERS'] = true;
					rightsOfUser['ACCESS_ANOMALIES_PAGE'] = true;
					rightsOfUser['ACCESS_APPROVER_OVERRIDE'] = true;
					rightsOfUser['ACCESS_CONFIG'] = true;
					rightsOfUser['ACCESS_SOD_CHECKER'] = true;
					rightsOfUser['ACCESS_REPORT'] = true;
					rightsOfUser['ACCESS_SOD_CLASHES'] = true;
					rightsOfUser['ACCESS_ROLES'] = true;
					rightsOfUser['ACCESS_SOR_USER_MAPPINGS'] = true;
					rightsOfUser['ACCESS_SYSTEMS_PAGE'] = true;
					rightsOfUser['ACCESS_REPORT_BROWSER'] = true;
					rightsOfUser['ACCESS_SYSTEM_ACCESS_REPORT'] = true;
					rightsOfUser['ACCESS_CHECK_APPROVERS_ACCESS'] = true;
					rightsOfUser['ACCESS_REPORT_CHASING'] = true;
					rightsOfUser['ACCESS_REPORT_REJECTED_USERS'] = true;
					rightsOfUser['ACCESS_APPROVAL_REQUESTS_PAGE'] = true;
					rightsOfUser['ACCESS_DASHBOARD'] = true;
					rightsOfUser['ACCESS_BLACKLIST_PAGE'] = true;
					rightsOfUser['ACCESS_AUDIT_LOG_PAGE'] = true;
					rightsOfUser['ACCESS_USER_ROLES_AUTO_REC_PAGE'] = true;
					rightsOfUser['ACCESS_USER_ROLE_CHECKER_PAGE'] = true;
					break;
				case 'HELPDESKS':
					rightsOfUser['ACCESS_SOD_CHECKER'] = true;
					rightsOfUser['ACCESS_SOR_USER_MAPPINGS'] = true;
					rightsOfUser['ACCESS_USER_ROLE_CHECKER_PAGE'] = true;
					break;
				case 'SUPER_APPROVERS':
					rightsOfUser['ACCESS_REPORT_BROWSER'] = true;
					rightsOfUser['ACCESS_REPORT'] = true;
					rightsOfUser['ACCESS_SOD_CLASHES'] = true;
					rightsOfUser['ACCESS_SOD_CHECKER'] = true;
					rightsOfUser['ACCESS_USER_ROLE_CHECKER_PAGE'] = true;
					break;
				case 'APPROVERS':
					rightsOfUser['ACCESS_REPORT_BROWSER'] = true;
					rightsOfUser['ACCESS_APPROVAL_REQUESTS_PAGE'] = true;
					rightsOfUser['ACCESS_REPORT'] = true;
					break;
				case 'REPORT_REASSIGNERS':
					rightsOfUser['ACCESS_REASSIGN_REPORTS'] = true;
					break;
				case 'AUDITORS':
					rightsOfUser['ACCESS_REPORT_REJECTED_USERS'] = true;
					rightsOfUser['ACCESS_ANOMALIES_PAGE'] = true;
					rightsOfUser['ACCESS_REPORT_BROWSER'] = true;
					rightsOfUser['ACCESS_SOD_CLASHES'] = true;
					rightsOfUser['ACCESS_CONFIG'] = true;
					rightsOfUser['ACCESS_SYSTEMS_PAGE'] = true;
					rightsOfUser['ACCESS_SYSTEM_ACCESS_REPORT'] = true;
					rightsOfUser['ACCESS_REPORT_CHASING'] = true;
					rightsOfUser['ACCESS_USER_ROLE_CHECKER_PAGE'] = true;
					rightsOfUser['ACCESS_APPROVAL_REQUESTS_PAGE'] = true;
					rightsOfUser['ACCESS_SOD_CHECKER'] = true;
					rightsOfUser['ACCESS_SOR_USER_MAPPINGS'] = true;
					break;
				case 'REVIEWERS':
					rightsOfUser['ACCESS_SYSTEM_ACCESS_REPORT'] = true;
					break;
			}
		}

		if (rights instanceof Array) {
			for (const r of rights) {
				if (rightsOfUser[r.trim()]) {
					return true;
				}
			}

			console.log('user not allowed (array)', rights, rightsOfUser);
			return false;
		}
		const allowed = rightsOfUser[rights.trim()];
		if (!allowed) {
			console.log('user not allowed', rights, rightsOfUser);
		}
		return allowed;
	}
}
